import { IBookingSchedulerState } from '../states'
import { BookingSchedulerActionTypes, BookingSchedulerTypeKeys } from '../types'

export const initialBookingSchedulerState: IBookingSchedulerState = {
  bookingSchedulers: [],
  isFetchingBookingSchedulers: false,
  isLoadingBookingScheduler: false,
  selectedBookingScheduler: null
}

const bookingScheduler = (
  state: IBookingSchedulerState = initialBookingSchedulerState,
  action: BookingSchedulerActionTypes
): IBookingSchedulerState => {
  switch (action.type) {
    case BookingSchedulerTypeKeys.FETCHING_BOOKING_SCHEDULERS:
      return { ...state, isFetchingBookingSchedulers: true }
    case BookingSchedulerTypeKeys.FETCH_BOOKING_SCHEDULERS_SUCCESSFUL:
      return {
        ...state,
        isFetchingBookingSchedulers: false,
        bookingSchedulers: action.payload
      }
    case BookingSchedulerTypeKeys.ADDING_BOOKING_SCHEDULER:
    case BookingSchedulerTypeKeys.EDITING_BOOKING_SCHEDULER:
    case BookingSchedulerTypeKeys.REMOVING_BOOKING_SCHEDULER:
      return { ...state, isLoadingBookingScheduler: true }
    case BookingSchedulerTypeKeys.ADD_BOOKING_SCHEDULER_SUCCESSFUL:
    case BookingSchedulerTypeKeys.EDIT_BOOKING_SCHEDULER_SUCCESSFUL:
    case BookingSchedulerTypeKeys.REMOVE_BOOKING_SCHEDULER_SUCCESSFUL:
      return {
        ...state,
        isLoadingBookingScheduler: false,
        selectedBookingScheduler: null
      }
    case BookingSchedulerTypeKeys.SET_SELECTED_BOOKING_SCHEDULER_MODAL:
      return {
        ...state,
        isLoadingBookingScheduler: false,
        selectedBookingScheduler: action.payload
      }
    default:
      return state
  }
}

export default bookingScheduler
